import type { WidgetDataContract } from "@nexus/widget-sdk";

/**
 * `protection-overview-event-hermes` v1 — one protected event's restreaming
 * server (ISP) blocking outcomes: how completely and how quickly ISPs acted
 * on a blocking request, grouped by country.
 */
export const RESTREAMING_SERVER_BLOCKING_CONTRACT: WidgetDataContract = {
  name: "protection-overview-event-hermes",
  version: 1,
};

export interface RestreamingServerBlockingIsp {
  name: string;
  countryCode: string;
  countryName: string;
  responseRate: number;
  responseCoverageRate: number;
  /** Coverage-rate accrual duration in minutes. */
  coverageDurationMin: number;
  /** Image reference of the country flag (see `WidgetAssetsContext`). */
  flag?: string | null;
}

export interface RestreamingServerBlockingData {
  responseRate: number;
  responseCoverageRate: number;
  isps: RestreamingServerBlockingIsp[];
}
